module.exports = __webpack_public_path__ + "static/media/NickZimmerman.6cb616c8.png";